import type { ComponentType } from 'react'
import { AudioAnnotationTask } from './audio-annotation/AudioAnnotationTask'
import { AudioTranscriptionTask } from './audio-transcription/AudioTranscriptionTask'

export type TaskRendererProps = {
  taskId: string
  taskIndex: number
  projectId: string
  captchaEnabled: boolean
  taskReportingEnabled: boolean
  onSubmitted: (taskId: string) => void
}

export const TASK_TYPE_COMPONENTS = new Map<string, ComponentType<TaskRendererProps>>([
  ['audio-annotation', AudioAnnotationTask],
  ['audio-transcription', AudioTranscriptionTask]
])
